import { useNotify } from "react-admin";
import { Box, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { settings } from "app";
import { getFile, getFileFromUrl } from "server/components/DownloadFile";

// `url` overrides the default DocumentService "private-documents" lookup for documents
// uploaded through another microservice's own endpoint (e.g. elective course documents).
const DocumentFileLink = ({ id, documentName, url }) => {
  const notify = useNotify();

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 1, cursor: "pointer" }}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        if (url) {
          getFileFromUrl(`${settings.gatewayApi}/${url}`, `${documentName}-${id}`, notify);
        } else {
          getFile(id, notify, "private");
        }
      }}
    >
      <DownloadIcon
        fontSize="small"
        color="primary"
      />
      <Typography
        sx={{ textDecoration: "underline" }}
        color="primary"
        fontSize={14}
      >
        {`${documentName}-${id}`}
      </Typography>
    </Box>
  );
};

export default DocumentFileLink;
